export enum PaymentType {
  PAYPAL = 'paypal',
  GGPLAY = 'ggplay',
  AMASON = 'amazon',
  VISA = 'visa'
}
